import React from 'react';
import {Props} from './model';
import {View} from 'react-native';
import {useTheme} from '../../../../../shared/theme';
import {useStyles} from '../../../../../shared/hooks/styles';
import {datePipe} from '../../../../../shared/pipes/date';
import {Text} from '../../../../../shared/components/text';
import {CardNumber} from '../../../../../shared/components/cardNumber';

export default (props: Props) => {
  const {dateUntil} = props;
  const theme = useTheme();

  const styles = useStyles(() => {
    return {
      container: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-evenly',
        backgroundColor: theme.color.cardBackground,
        height: 69,
        paddingHorizontal: 30,
      },
      dateContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-evenly',
        paddingHorizontal: 20,
        marginTop: 8,
      },
      dateLabel: {
        ...theme.fonts.label,
        color: theme.color.labelText,
      },
      dateValue: {
        ...theme.fonts.bodySmallLight,
        color: theme.color.labelText,
        marginLeft: 8,
        paddingRight: 2,
        marginRight: -2,
      },
      numberContainer: {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        justifyContent: 'flex-end',
        alignItems: 'center',
      },
      cardNumber: {
        minWidth: 230,
      },
      cardNumberText: {
        ...theme.fonts.h5,
        fontSize: Math.min(20, Number(theme.fonts.h5.fontSize)),
        lineHeight: Math.min(24, Number(theme.fonts.h5.lineHeight)),
        color: theme.color.cardText,
      },
      eyeIcon: {marginLeft: 20},
    };
  });

  return (
    <View testID='use-info-id'>
      <View style={styles.container}>
        <CardNumber
          useLabel
          hiddenIconColor={theme.color.cardText}
          visibleIconColor={theme.color.cardText}
          style={styles.cardNumber}
          textStyle={styles.cardNumberText}
          iconProps={{style: styles.eyeIcon}}
        />
      </View>
      <View testID='date-container-id' style={styles.dateContainer}>
        <View testID='date-nested-container-id' style={styles.numberContainer}>
          <Text testID='date-label-id' style={styles.dateLabel} numberOfLines={1}>
            Дата выдачи
          </Text>
          <Text testID='date-text-id' style={styles.dateValue} numberOfLines={1}>
            {datePipe(dateUntil)}
          </Text>
        </View>
      </View>
    </View>
  );
};
